import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_folder",
  "use": "icon-project_folder-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_folder\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M26 10.794v10.57c0 .903-.768 1.636-1.714 1.636H3.714C2.768 23 2 22.267 2 21.364V6.636C2 5.733 2.768 5 3.714 5h9.819\" stroke-linecap=\"round\" /><path d=\"M14 6h7.435C22.852 6 24 7.093 24 8.44V11h0\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M14 5l3.68 6H26\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol